import { z } from 'zod'
export const setPresentationAsInterestingSchema = z.object({
  presentationId: z.string().uuid(),
})
export type SetPresentationAsInteresting = z.infer<
  typeof setPresentationAsInterestingSchema
>
